export const QUARTER_OPTIONS = [1, 2, 3, 4].map((quarter) => ({
  value: quarter,
  label: String(quarter),
}));

export const getPeriodYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return [currentYear + 1, currentYear, currentYear - 1].map((year) => ({
    value: year,
    label: String(year),
  }));
};

export const getReportYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years: { value: number; label: string }[] = [];
  for (let i = currentYear; i > currentYear - 20; i--) {
    years.push({ value: i, label: String(i) });
  }
  return years;
};
